import React from 'react';

import Home from '@src/pages/home';
import SupportCenter from '@src/pages/supportCenter';

export type RouterConfig = {
  name: string
  path: string
  component?: React.ComponentType
  redirect?: string
  /**
   * 路由所属模块
   */
  moduleKey: string
}
export type Page = Omit<RouterConfig, 'name'>

export const pages = {
  home: {
    path: '/',
    component: Home,
    moduleKey: 'home',
  },
  supportCenter: {
    path: '/supportcenter',
    redirect: '/supportcenter/article',
    moduleKey: 'supportCenter',
  },
  supportCenterSdk: {
    path: '/supportcenter/article',
    component: SupportCenter,
    moduleKey: 'supportCenter',
  },
};

export type RouterKey = keyof typeof pages

const routers: RouterConfig[] = Object.keys(pages).map((key) => {
  const name = key as keyof typeof pages;
  return {
    name,
    ...pages[name],
  } as RouterConfig;
});

export { routers };
